const isDevelopment = process.env.NODE_ENV === 'development';

// Override global console in production
if (!isDevelopment) {
  console.log = () => {};
  console.warn = () => {};
  // Keep console.error for actual errors in production
}

// Export explicit logger functions (for future refactoring)
export const logger = {
    log: (...args) => {
      if (isDevelopment) {
        console.log(...args);
      }
    },
    error: (...args) => {
      if (isDevelopment) {
        console.error(...args);
      }
    },
    warn: (...args) => {
      if (isDevelopment) {
        console.warn(...args);
      }
    }
  };